const CDN_BASE = "https://jiritsu.fra1.cdn.digitaloceanspaces.com";

export function resolveThemeAsset(themeSlug: string, assetPath: string): string {
  return `${CDN_BASE}/themes/${themeSlug}/${assetPath}`;
}
